import { TimeUnit } from 'bz-utilities/global/date';

const Session = {
  set(key: string, value: object, ttlMs?: number | undefined) {
    const data = {
      ...value,
      expiresAt: ttlMs ? Date.now() + ttlMs : null
    };
    sessionStorage.setItem(key, JSON.stringify(data));
  },

  get(key: string) {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;

    try {
      const parsed = JSON.parse(raw);
      if (parsed.expiresAt && Date.now() > parsed.expiresAt) {
        sessionStorage.removeItem(key);
        return null; // Expired
      }
      return parsed;
    } catch (e) {
      console.warn(`Failed to parse sessionStorage key "${key}"`, e);
      sessionStorage.removeItem(key); // Clean up bad data
      return null;
    }
  },

  remove(key: string) {
    sessionStorage.removeItem(key);
  },

  clear() {
    sessionStorage.clear();
  },

  has(key: string) {
    return Session.get(key) !== null;
  }
};

const SessionTTMs = {
  TEMP_BOOKING: 10 * TimeUnit.minute // 10 minutes
};

export { Session, SessionTTMs };
export default Session;
